// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1bnSo","content":"styles_content__3rRxR","imagen":"styles_imagen__1Tedn"};